import React from "react";
import ContentLoader from "react-content-loader";
import {
  GoGraph,
  GoPeople,
  GoOrganization,
  GoCreditCard,
  GoLaw,
  GoSearch,
  GoArrowUp,
  GoArrowDown,
} from "react-icons/go";
import { HiOutlineChartBar } from "react-icons/hi";

const ClientsReformaLoadingSkeleton = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  return (
    <div className="reforma-tab">
      {/* Botões de Cenário */}
      <div className="cenario-buttons">
        {["2027", "2029", "2030", "2031", "2033"].map((year, i) => (
          <button key={year} className={`cenario-btn ${i === 0 ? "active" : ""}`}>
            <span className="cenario-year">{year}</span>
            <span className="cenario-label">
              {i === 0 ? "Início IVA Dual" : i === 4 ? "IVA Dual Pleno" : `Transição ${(i - 1) * 20 + 40}%`}
            </span>
          </button>
        ))}
      </div>

      {/* Linha 1 - Visão Geral */}
      <div className="kpi-cards main-stats">
        {[
          { icon: GoGraph, label: "Faturamento Total", className: "primary" },
          { icon: GoPeople, label: "Total de Clientes", className: "warning" },
          { icon: GoOrganization, label: "Segmentos Atuantes", className: "info" },
          { icon: GoGraph, label: "Alíquota Efetiva (2027)", className: "cte" },
        ].map((item, i) => (
          <div key={`kpi-main-${i}`} className={`kpi-card ${item.className}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={100}
                    height={20}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="100" height="20" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Linha 2 - Débitos Tributários Atuais */}
      <div className="kpi-cards secondary-stats">
        {[
          { icon: GoCreditCard, label: "Débitos Tributários Atuais", className: "warning with-progress" },
          { icon: GoLaw, label: "ICMS", className: "" },
          { icon: GoLaw, label: "COFINS", className: "nfe" },
          { icon: GoLaw, label: "PIS", className: "info" },
          { icon: GoLaw, label: "ISS + IPI", className: "cte" },
        ].map((item, i) => (
          <div key={`kpi-atual-${i}`} className={`kpi-card compact ${item.className}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={18}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="80" height="18" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Linha 3 - IVA Dual Projetado */}
      <div className="kpi-cards secondary-stats">
        {[
          { icon: GoCreditCard, label: "IVA Dual Projetado (2027)", className: "success with-progress" },
          { icon: GoLaw, label: "CBS", className: "success" },
          { icon: GoLaw, label: "Alíquota CBS", className: "info" },
          { icon: GoLaw, label: "IBS", className: "primary" },
          { icon: GoLaw, label: "Alíquota IBS", className: "cte" },
        ].map((item, i) => (
          <div key={`kpi-dual-${i}`} className={`kpi-card compact ${item.className}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={18}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="80" height="18" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Busca de Clientes */}
      <div className="reforma-search">
        <div className="search-input-wrapper">
          <GoSearch className="search-icon" />
          <ContentLoader
            speed={2}
            width={300}
            height={14}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
            style={{ marginLeft: "8px" }}
          >
            <rect x="0" y="0" rx="3" ry="3" width="300" height="14" />
          </ContentLoader>
        </div>
      </div>

      {/* Tabela de Clientes com Impostos + Card Impacto */}
      <div className="reforma-content-row">
        <div className="reforma-products-table">
          <div className="table-header">
            <div className="header-cell produto">Cliente</div>
            <div className="header-cell">ICMS</div>
            <div className="header-cell">PIS/COFINS</div>
            <div className="header-cell">ISS/IPI</div>
            <div className="header-cell">CBS</div>
            <div className="header-cell">IBS</div>
          </div>
          <div className="table-body">
            {[...Array(10)].map((_, i) => (
              <div
                key={`client-${i}`}
                className="product-row"
                style={{
                  "--product-color": ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444"][i % 5],
                }}
              >
                <div className="product-info">
                  <span className="product-code">
                    <ContentLoader
                      speed={2}
                      width={140}
                      height={12}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="140" height="12" />
                    </ContentLoader>
                  </span>
                  <span className="product-name">
                    <ContentLoader
                      speed={2}
                      width={200}
                      height={12}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="200" height="12" />
                    </ContentLoader>
                  </span>
                </div>
                {[...Array(5)].map((_, j) => (
                  <div key={`tax-${j}`} className="tax-value">
                    <ContentLoader
                      speed={2}
                      width={70}
                      height={12}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="70" height="12" />
                    </ContentLoader>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Card Impacto da Reforma */}
        <div className="impacto-sidebar">
          {/* Card Principal - Impacto */}
          <div className="impacto-main-card">
            <div className="impacto-header">
              <div className="impacto-icon">
                <GoGraph />
              </div>
              <span className="impacto-badge medio">MÉDIO IMPACTO</span>
            </div>
            <span className="impacto-title">Impacto da Reforma</span>
            <span className="impacto-value">
              <ContentLoader
                speed={2}
                width={120}
                height={24}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="4" ry="4" width="120" height="24" />
              </ContentLoader>
            </span>
            <span className="impacto-desc">
              <ContentLoader
                speed={2}
                width={160}
                height={12}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="160" height="12" />
              </ContentLoader>
            </span>
            <div className="impacto-variation">
              <ContentLoader
                speed={2}
                width={100}
                height={14}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="100" height="14" />
              </ContentLoader>
            </div>
          </div>

          {/* Card Comparativo */}
          <div className="impacto-compare-card">
            <span className="compare-title">Comparativo de Carga</span>
            <div className="compare-items">
              {["Sistema Atual", "IVA Dual (2027)", "Diferença"].map((label, i) => (
                <div key={`compare-${i}`} className={`compare-item ${i === 2 ? "highlight" : ""}`}>
                  <span className="compare-label">{label}</span>
                  <span className={`compare-value ${i === 0 ? "atual" : i === 1 ? "novo" : "diff"}`}>
                    <ContentLoader
                      speed={2}
                      width={90}
                      height={14}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="90" height="14" />
                    </ContentLoader>
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Card Alíquotas */}
          <div className="impacto-aliquotas-card">
            <span className="aliquotas-title">Alíquotas Projetadas</span>
            <div className="aliquota-row">
              {["CBS", "IBS"].map((sigla) => (
                <div key={sigla} className="aliquota-item">
                  <span className="aliquota-sigla">{sigla}</span>
                  <span className="aliquota-valor">
                    <ContentLoader
                      speed={2}
                      width={50}
                      height={14}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="50" height="14" />
                    </ContentLoader>
                  </span>
                </div>
              ))}
            </div>
            <div className="aliquota-total">
              <span>Alíquota Efetiva Total</span>
              <span className="total-valor">
                <ContentLoader
                  speed={2}
                  width={60}
                  height={16}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="60" height="16" />
                </ContentLoader>
              </span>
            </div>
          </div>

          {/* Card Timeline */}
          <div className="impacto-timeline-card">
            <span className="timeline-title">Cronograma de Transição</span>
            <div className="timeline-steps">
              {[
                { year: "2027", desc: "Início" },
                { year: "2029", desc: "40%" },
                { year: "2033", desc: "100%" },
              ].map((step, i) => (
                <div key={step.year} className={`timeline-step ${i === 0 ? "active" : ""}`}>
                  <span className="step-year">{step.year}</span>
                  <span className="step-desc">{step.desc}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Gráficos de Barras */}
      <div className="reforma-charts-row">
        {/* Gráfico 1 - Comparativo de Tributos */}
        <div className="reforma-chart-card">
          <div className="chart-header">
            <div className="chart-title">
              <HiOutlineChartBar className="chart-icon" />
              <span>Comparativo de Tributos</span>
            </div>
            <span className="chart-subtitle">Sistema Atual vs IVA Dual</span>
          </div>
          <div className="chart-container">
            <ContentLoader
              speed={2}
              width={600}
              height={380}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
            >
              {/* Barras do gráfico comparativo */}
              {[...Array(6)].map((_, i) => {
                const x = 40 + i * 95;
                const heights = [280, 200, 180, 160, 250, 220];
                return (
                  <g key={i}>
                    <rect x={x} y={380 - heights[i]} rx="4" ry="4" width="35" height={heights[i]} />
                    <rect x={x + 40} y={380 - heights[i] * 0.7} rx="4" ry="4" width="35" height={heights[i] * 0.7} />
                  </g>
                );
              })}
            </ContentLoader>
          </div>
        </div>

        {/* Gráfico 2 - Evolução Temporal */}
        <div className="reforma-chart-card">
          <div className="chart-header">
            <div className="chart-title">
              <GoGraph className="chart-icon" />
              <span>Evolução Temporal</span>
            </div>
            <span className="chart-subtitle">Projeção 2027-2033</span>
          </div>
          <div className="chart-container">
            <ContentLoader
              speed={2}
              width={600}
              height={380}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
            >
              {/* Barras do gráfico de evolução */}
              {[...Array(7)].map((_, i) => {
                const x = 40 + i * 80;
                const heights = [200, 220, 240, 260, 280, 300, 320];
                return (
                  <rect key={i} x={x} y={380 - heights[i]} rx="4" ry="4" width="50" height={heights[i]} />
                );
              })}
            </ContentLoader>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsReformaLoadingSkeleton;
